import axios from '../axios'
import { API_BASE_URL } from '../constants'

interface SearchParams {
  query: string
  page: number
  perPage: number
}

const searchVoicySounds = async ({ query, page, perPage }: SearchParams) => {
  const response = await axios.get(`${API_BASE_URL}/voicy-sounds`, {
    params: {
      query,
      page,
      perPage,
    },
  })

  return {
    voicySounds: response.data,
    totalPages: Number(response.headers['x-total-pages']),
  }
}

export default searchVoicySounds
